module.exports = __webpack_public_path__ + "img/tab-chat-active.042d06b.png";